import React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import SelfSchedulingModel from '../../../../models/SelfScheduling'

import './SelfSchedulingInsurance.sass'

export type SelfSchedulingInsuranceProps = {
    insurance: Models.SelfSchedulingInsurance
    updateInsurance: (insurance: Models.SelfSchedulingInsurance) => void
}

const moduleName = 'self-scheduling-insurance'

function SelfSchedulingInsurance(props: SelfSchedulingInsuranceProps) {
    const { insurance = SelfSchedulingModel.defaultInsurance } = props

    function updateInsurance(e: RadioChangeEvent) {
        props.updateInsurance(e.target.value as Models.SelfSchedulingInsurance)
    }

    return (
        <div className={moduleName}>
            <h3 className={`${moduleName}__title`}>Insurance</h3>
            <div className={`${moduleName}__radio-buttons-wrapper`}>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="insurance-required"
                        checked={insurance === 'required'}
                        onChange={updateInsurance}
                        name="radio-widget-style"
                        value="required"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Required
                    </VyneRadio>
                </div>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="insurance-optional"
                        checked={insurance === 'optional'}
                        onChange={updateInsurance}
                        name="radio-widget-style"
                        value="optional"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Optional
                    </VyneRadio>
                </div>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="insurance-none"
                        checked={insurance === 'none'}
                        onChange={updateInsurance}
                        name="radio-widget-style"
                        value="none"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        None
                    </VyneRadio>
                </div>
            </div>
        </div>
    )
}

export default SelfSchedulingInsurance
